var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProphetRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9ac450;\n      }\n\n      .cls-2 {\n        fill: #f4f8e9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    className: "cls-1",
    cx: 50.004,
    cy: 50.0002,
    r: 46.5487
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    className: "cls-2",
    d: "M50.0041,6.9066A43.0934,43.0934,0,1,1,6.9107,50,43.0935,43.0935,0,0,1,50.0041,6.9066m0-6.91A50.0038,50.0038,0,1,0,100,50,50.0526,50.0526,0,0,0,50.0041-.0038Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    className: "cls-2",
    d: "M76.56,46.9262A23.0593,23.0593,0,0,1,53.5487,23.8993a3.5525,3.5525,0,1,0-7.105,0,23.0675,23.0675,0,0,1-23.019,23.0269,3.5486,3.5486,0,0,0,0,7.0971A22.93,22.93,0,0,1,46.4192,76.215a3.5525,3.5525,0,0,0,3.5525,3.4308h0a3.5526,3.5526,0,0,0,3.5525-3.4308A22.93,22.93,0,0,1,76.5107,54.0233a3.5443,3.5443,0,0,0,3.5446-3.5446v-.0079A3.5528,3.5528,0,0,0,76.56,46.9262Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProphetRoundIcon);
export default __webpack_public_path__ + "static/media/prophet-round-icon.0c4ca3a7a49e9a0592fbf3e441db098a.svg";
export { ForwardRef as ReactComponent };